module.exports = __webpack_public_path__ + "img/waiting-list.126a028f.svg";